import { FunctionComponent } from 'react';
import Button from 'components/UI/V3/Button/Button';
import { type AutomationTemplate } from './automationTemplates';
import styles from './AutomationTemplatesGallery.module.scss';

interface Props {
    template: AutomationTemplate;
    onUse: () => void;
}

const AutomationTemplateCard: FunctionComponent<Props> = ({ template, onUse }) => (
    <div className={styles.card}>
        <span className={styles.scopeChip}>{template.serviceScope}</span>
        <h4 className={styles.cardTitle}>{template.name}</h4>
        <p className={styles.cardDescription}>{template.description}</p>
        <div className={styles.cardFooter}>
            <Button
                label="Use Template"
                variant="green"
                fullWidth
                onClick={onUse}
            />
        </div>
    </div>
);

export default AutomationTemplateCard;
